<template>
  <b-modal id="modal-cadastro-imagem" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true">
    <form>
      <h6><i class="fas fa-key"></i>Adicionar imagens</h6>
       <div class="col-12 col-md-12">
          <div class="form-group">
            <label for="imagens"></label>
            <div class="input-group mb-3">
              <b-form-file
                v-model="imagens_selecionadas"
                placeholder="Escolha uma imagem"
                drop-placeholder="Solte um arquivo aqui..."
                browse-text="Selecionar"
                accept="image/jpeg, image/png"
              ></b-form-file>
            </div>
          </div>
          <div class="form-group" v-if="(imagens.length > 0)">
            <label  class="mt-3" for="lsita">Imagens selecionadas:</label>
            <div class="mt-2" v-for="imagem in imagens" :key="imagem.name">
              {{ imagem && imagem.name }} <a href="javascript:void(0)" v-b-tooltip.hover title="Excluir" @click="excluirImagem(imagem)"><i class="fas fa-trash-alt"></i></a>
            </div>
          </div>
        </div>
       <div class="text-center">
        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
          <a href="javascript:void(0)" id='cadastrar' class="btn btn-primary mr-3 mb-2 mb-md-0" @click="salvar">Salvar</a>
          <a href="javascript:void(0)" class="btn btn-secondary mr-3 mb-2 mb-md-0" @click="$bvModal.hide('modal-cadastro-imagem')">Cancelar</a>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import Swal from 'sweetalert2'
import ResponseUtils from '@/core/util/response-utils'
import ImagemAPI from '@/api/imagem-api'

export default {
  name: 'ModalCadastroImagem',
  inheritAttrs: false,
  data () {
    return {
      imagens: [],
      imagens_selecionadas: null
    }
  },

  mounted () {
    this.imagens = []
    this.imagens_selecionadas = null
  },

  methods: {
    show: function () {
      this.$bvModal.show('modal-cadastro-imagem')
    },

    excluirImagem: function (imagem) {
      this.imagens = this.imagens.filter(item => (
        item.name !== imagem.name
      ))
    },

    salvar: function () {
      const loader = this.$loading.show()

      ImagemAPI.salvar(this.imagens).then(data => {
        loader.hide()

        Swal.fire({
          icon: 'success',
          confirmButtonText: 'Ok',
          title: 'Imagens salvas com sucesso!'
        }).then((result) => {
          if (result.value) {
            this.imagens.imagens = []
            this.$bvModal.hide('modal-cadastro-imagem')
          } else {
            this.$bvModal.hide('modal-cadastro-imagem')
          }
        })
      }).catch(error => ResponseUtils.handleError(error, loader))
    }
  },

  watch: {
    imagens_selecionadas: function () {
      if (this.imagens_selecionadas) {
        this.excluirImagem(this.imagens_selecionadas)
        this.imagens.push(this.imagens_selecionadas)
      }
    }
  }
}

</script>
